import { AfterContentInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractBaseDetailsComponent } from '../../../core/component/abstract-base-details-component';
import { CommonSelectListService } from '../../../shared/service/common-select-list.service';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SoDetailModal } from '../modal/so-detail-modal';
import { ProductModal } from '../../product/modal/product-modal';
import { MoistureModal } from '../../moisture/modal/moisture-modal';
import { PHModal } from '../../ph/modal/phmodal';
import { SolubilityModal } from '../../solubility/modal/solubility-modal';
import { Puritymodal } from '../../purity/modal/puritymodal';
import { PackingModel } from '../../packing/model/packing-model';
import { PackingDetailModel } from '../../packing/model/packing-detail-model';
import { ModuleUrlsConstant } from '../../../shared/add-refresh/constant/module-urls-constant';
import { soModuleParamConfigModel } from '../modal/so-module-param-config-model';
import { ModuleParamGlobConfigService } from '../../../core/service/moduleFieldConfig/module-param-glob-config.service';
import { SystemConfigSettingModel } from '../../../shared/model/system-config-setting-model';
import { SystemConfigService } from '../../../system-config/service/system-config.service';
import { PartyModal } from '../../party/modal/party-modal';
import { DefaultMaterialPropertiesService } from '../../../shared/service/default-material-properties.service';
import { commonItemProperties, LastSOPrice, SalesOrderModal } from '../modal/sales-order-modal';
import { ItemProperties, ItemPropertyValues } from '../../funnel/modal/funnel-modal';
import { POItemProperties } from '../../purchase-order/purchase-order-detail-add-update/purchase-order-detail-add-update.component';

@Component({
  selector: 'app-sales-order-detail-add-update',
  templateUrl: './sales-order-detail-add-update.component.html',
  styleUrls: ['./sales-order-detail-add-update.component.css'],
})
export class SalesOrderDetailAddUpdateComponent
  extends AbstractBaseDetailsComponent
  implements OnInit, AfterContentInit
{
  public submitted = false;
  public formGroupSo: FormGroup;
  public ItemList: Array<ProductModal>;
  public itemCodeList: Array<any>;
  public itemCodeProperties: Array<any>;
  public moistureList: Array<MoistureModal>;
  public phList: Array<PHModal>;
  public solubilityList: Array<SolubilityModal>;
  public purityList: Array<Puritymodal>;
  propertyUrls = ModuleUrlsConstant;
  listofData: Array<SoDetailModal>;
  addMatirail: boolean;

  @Input() getAllFilter: boolean;
  @Input() soNumber: boolean;
  @Input() isUpdateComponentIML: boolean;
  @Input() isImlUpdateAdd: boolean;
  @Input() setNoCount: number;
  @Input()
  public parentList: SalesOrderModal;

  @Input()
  public data: SoDetailModal;
  public LidData: any = {};
  public bottomMoisture: any = {};
  public lidMoisture: any = {};
  public count: any = 1;
  public BottomData: any = {};
  @Input() public isPkgTypeSupportOn: boolean;
  @Output('onSave')
  public saveCallback: EventEmitter<SoDetailModal> = new EventEmitter<SoDetailModal>();
  @Output('listSave')
  public listSaveCallback: EventEmitter<SoDetailModal[]> = new EventEmitter<SoDetailModal[]>();
  @Output('onCancel')
  public cancelCallback: EventEmitter<SoDetailModal> = new EventEmitter<SoDetailModal>();
  public packingList: PackingModel[];
  public packageCapacityList: PackingDetailModel[];
  public itemProperties: Array<commonItemProperties>;
  private dynamicProp = [];

  receivedSecondaryQuantity: number;
  public isSecondaryQuantity: boolean;
  product: ProductModal;

  public moduleParams: soModuleParamConfigModel;
  sysConfigProductModel: SystemConfigSettingModel = new SystemConfigSettingModel(this.systemConfigService);

  // New Changes #14102020Dk
  @Input() currentParty: PartyModal;
  @Input() partnerName: string;
  public labelProductList: Array<ProductModal>;
  public filterLabelProductList: Array<ProductModal>;
  isDiagonal: boolean = false;
  lastSoPrice: LastSOPrice;
  detailEdit = false;
  public editIndex: number;
  totalFinalAmt: number;
  totalProductAmt: number;
  totalProductsWeight: number;
  constructor(
    private commonService: CommonSelectListService,
    public toaster: ToastrService,
    private formBuilder: FormBuilder,
    private systemConfigService: SystemConfigService,
    public defaultMaterialPropertiesService: DefaultMaterialPropertiesService,
    private moduleParamConfigGlob: ModuleParamGlobConfigService
  ) {
    super(toaster);
  }

  ngOnInit() {
    this.isDiagonal = 'Diagonal' == this.partnerName;
    if (!this.data) {
      this.data = new SoDetailModal();
    }
    this.setData();
    this.setValidation();
    if (this.sysConfigProductModel.isItemCodeSupport) this.getItemCodeList();
    this.getItemList();
    if (this.isPkgTypeSupportOn) {
      this.getPackingList();
    }
    if (this.isUpdateComponentIML) {
      this.createFormControl(null, this.data);
      this.formGroupSo.controls.isLabelProduct.disabled;
      //this.formGroupSo.controls.productName.disable();
    }
    this.sysInit();
    this.listofData = new Array<SoDetailModal>();
  }

  sysInit() {
    this.isSecondaryQuantity = this.configurationCheck('SECONDARY_STOCK_SUPPORT');
  }
  configurationCheck(param: string) {
    return this.systemConfigService.sysConfig ? this.systemConfigService.sysConfig.get(param) === 'YES' : false;
  }

  public getProductTotal() {
    this.data.totalAmt = 0;
    if (this.data.price) this.data.price = Number(this.data.price);

    if (this.data) {
      this.data.totalAmt = (this.data.price ? this.data.price : 0) * (this.data.weight ? this.data.weight : 0);
    }
    this.getDiscountTotal();
  }

  // getDiscountTotal() {
  //   this.data.totalDiscount = 0;
  //   this.data.finalAmt = 0;
  //   if (this.data.discount) {
  //     this.data.totalDiscount = (this.data.totalAmt * this.data.discount) / 100;
  //     this.data.finalAmt = this.data.totalAmt - this.data.totalDiscount;
  //   } else {
  //     this.data.finalAmt = this.data.totalAmt;
  //   }
  // }

  getDiscountTotal() {
    this.data.totalDiscount = 0;
    this.data.finalAmt = 0;
    if (this.data.discount) {
      this.data.totalDiscount = (this.data.totalAmt * this.data.discount) / 100;
    } else {
      this.data.finalAmt = this.data.totalAmt;
    }
    this.data.gstAmount =
      (this.data.totalAmt - this.data.totalDiscount) * (this.data.gst / 100);
    this.data.finalAmt = this.data.totalAmt - this.data.totalDiscount + this.data.gstAmount;
  }

  public getTotal() {
    this.totalFinalAmt = 0;
    this.totalProductAmt = 0;
    this.totalProductsWeight = 0;
    if (this.listofData && this.listofData.length > 0) {
      this.totalFinalAmt = this.listofData.reduce(
        (sum, item) => sum + parseFloat('' + (item.finalAmt ? item.finalAmt : 0)),
        0
      );
      this.totalProductAmt = this.listofData.reduce(
        (sum, item) => sum + parseFloat('' + (item.totalAmt ? item.totalAmt : 0)),
        0
      );
      this.totalProductsWeight = this.listofData.reduce(
        (sum, item) => sum + parseFloat('' + (item.weight ? item.weight : 0)),
        0
      );
    }
  }

  itemsPropertystring(arr1) {
    let finalString = [];
    arr1.forEach((ar1) => {
      ar1.itemPropertyValues.forEach((ar2) => {
        let Str = ar1.abbreviation + ' ' + ar2.name;
        finalString.push(Str);
      });
    });
    console.log('string=>', finalString.toString());

    return finalString.toString();
  }

  onAddMaterialClick() {
    let addMatirail: boolean = false;
    if (this.formGroupSo.invalid) {
      if(this.formGroupSo.get('weight').value != null && this.formGroupSo.get('weight').value != '' && this.formGroupSo.get('weight').invalid){
        this.toaster.error('Please Enter Quantity Multiple Of Packsize', 'Error');
      } else {
        this.toaster.error('Please fill all the details', 'Error');
      }
      return (this.submitted = true);
    }
    this.submitted = false;
    if (this.detailEdit) {
      var tmpFunProd = this.productDetail();
      if (this.isDiagonal) {
        // if (tmpFunProd.pack == '' || tmpFunProd.pack == null) {
        //   return this.toaster.error('Please Enter PackSize of Product');
        // } else 
        if (tmpFunProd.pack == 0) {
          return this.toaster.error("Entered Product PackSize Can't be Zero");
        } else if (tmpFunProd.weight == 0) {
          return this.toaster.error("Entered Product Quantity Can't be Zero");
        } else if (tmpFunProd.price == 0) {
          return this.toaster.error("Entered Product Price Can't be Zero");
        }
      } else {
        if (tmpFunProd.weight == 0) {
          return this.toaster.error("Entered Product Quantity Can't be Zero");
        } else if (tmpFunProd.price == 0) {
          return this.toaster.error("Entered Product Price Can't be Zero");
        }
      }
      this.listofData[this.editIndex] = tmpFunProd;
      this.getTotal();
      this.data = new SoDetailModal();
      this.resetData3();
      return (this.detailEdit = false);
    }

    if (this.data && !this.detailEdit) {
      var tmpFunProd = this.productDetail();
      if (!this.listofData) {
        this.listofData = Array<SoDetailModal>();
      }
      if (this.isDiagonal) {
        // if (tmpFunProd.pack == '' || tmpFunProd.pack == null) {
        //   return this.toaster.error('Please Enter PackSize of Product');
        // } else 
        if (tmpFunProd.pack == 0) {
          return this.toaster.error("Entered Product PackSize Can't be Zero");
        } else if (tmpFunProd.weight == 0) {
          return this.toaster.error("Entered Product Quantity Can't be Zero");
        } else if (tmpFunProd.price == 0) {
          return this.toaster.error("Entered Product Price Can't be Zero");
        }
      } else {
        if (tmpFunProd.weight == 0) {
          return this.toaster.error("Entered Product Quantity Can't be Zero");
        } else if (tmpFunProd.price == 0) {
          return this.toaster.error("Entered Product Price Can't be Zero");
        }
      }

      if (this.listofData && this.listofData.length > 0) {
        this.listofData.forEach((matirail) => {
          if (matirail.item.id === this.data.item.id) {
            if (
              this.itemsPropertystring(matirail.itemProperties) === this.itemsPropertystring(this.data.itemProperties)
            ) {
              if (confirm('Item already exists in list do you want to upadate Quantity')) {
                matirail.weight = Number(this.data.weight) + Number(matirail.weight);
                matirail.price = this.data.price;
                matirail.totalAmt = this.data.totalAmt;
                addMatirail = true;

                this.toaster.success('Quantity updated successfully');
                this.resetData3();
                return;
              } else {
                addMatirail = true;
                return;
              }
            }
          }
        });
      }

      if (this.parentList && this.parentList.salesOrderItemDetails) {
        this.parentList.salesOrderItemDetails.forEach((matirail) => {
          if (matirail.item.id === this.data.item.id) {
            if (
              this.itemsPropertystring(matirail.itemProperties) === this.itemsPropertystring(this.data.itemProperties)
            ) {
              if (confirm('Item already exists in list do you want to upadate Quantity')) {
                matirail.weight = Number(this.data.weight) + Number(matirail.weight);
                matirail.price = this.data.price;
                matirail.totalAmt = this.data.totalAmt;
                addMatirail = true;
                this.toaster.success('Quantity updated successfully');
                this.resetData3();
                return;
              } else {
                addMatirail = true;
                return;
              }
            }
          }
        });
      }

      if (!addMatirail) {
        this.listofData.push(Object.assign({}, tmpFunProd));
        this.resetData3();
        this.submitted = false;
        this.editIndex = undefined;
      }
      this.getTotal();
    }
  }

  onEditClick(i: number) {
    this.resetData3();
    this.data = new SoDetailModal();
    this.detailEdit = true;
    this.editIndex = i;

    if (this.listofData && this.listofData.length > 0) {
      this.data = JSON.parse(JSON.stringify(this.listofData[i]));
      this.createFormControls(null, this.data);
      this.getTotal();
      //this.cdr.detectChanges();
    }
  }

  onDeleteClick(i: number) {
    this.data = new SoDetailModal();
    if (this.listofData && this.listofData.length > 0) {
      this.getTotal();
      if (confirm('Are you sure?')) {
        this.listofData.splice(i, 1);
      }
    }
  }

  createFormControls(item: ProductModal, inwardDetails: SoDetailModal) {
    if (item || (inwardDetails && inwardDetails.item)) {
      var itemId = item ? item.id : inwardDetails.item.id;
      this.commonService.getItemById(itemId).subscribe((item) => {
        // if (!this.detailEdit) {
        //   this.data.item = item.data;
        //   this.data.multipleQtyNo = this.data.item.packSize;
        // }
        // if (!this.isUpdate) {
        //   this.data.item = item.data;
        //   this.data.multipleQtyNo = this.data.item.packSize;
        // }
        this.itemProperties = item.data.itemPropertyRels;
        var time = new Date().getTime().toString();
        this.itemProperties.forEach((d) => (d.time = time));
        this.itemProperties.forEach((prop) => {
          // if (prop.itemProperty.isCalculatedProperty) {
          //   this.isCalculatedProperty = true;
          // }
          var ctrlName = prop.itemProperty.name + '_' + prop.itemProperty.id + '_' + time;
          var find = inwardDetails ? inwardDetails.itemProp.find((ip) => ip.id == prop.itemProperty.id) : null;
          //
          // if(quotationDetails)
          // prop.itemProperty.value = find ? find.itemPropertyValues[0] : '';
          // else
          // prop.itemProperty.value = prop.itemProperty ? prop.itemProperty.itemPropertyValues[0] : '';
          if (!this.isImlUpdateAdd && !this.detailEdit) {
            if (
              prop.itemProperty &&
              prop.itemProperty.itemPropertyValues &&
              prop.itemProperty.itemPropertyValues.length == 1
            ) {
              this.formGroupSo.addControl(ctrlName, this.formBuilder.control(prop.itemProperty.itemPropertyValues[0]));
            } else {
              this.formGroupSo.addControl(ctrlName, this.formBuilder.control(''));
            }
          } else {
            this.formGroupSo.addControl(ctrlName, this.formBuilder.control(find ? find.itemPropertyValues[0] : ''));
          }

          if (this.formGroupSo.get(ctrlName)) {
            this.formGroupSo.get(ctrlName).setValidators(Validators.required);
          }
          this.dynamicProp.push(ctrlName);
        });
      });
    }
  }

  resetData3() {
    this.data = new SoDetailModal();

    this.itemProperties = [];
    this.dynamicProp = [];
    if (this.detailEdit) {
      this.detailEdit = false;
    }
    this.formGroupSo.get('conversionFactor').reset();
    this.formGroupSo.get('receivedSecondaryQuantity').reset();
    //this.formGroupSo.reset();
    //this.cdr.detectChanges();
  }

  updateSecondaryUOM() {
    if (this.data.conversionFactor) {
      this.receivedSecondaryQuantity = this.data.conversionFactor * this.data.weight;
    } else {
      this.receivedSecondaryQuantity = this.data.item.conversionFactor * this.data.weight;
    }
    this.data.receivedSecondaryQuantity = this.receivedSecondaryQuantity;
  }

  checkSystemParametersValidation() {
    if (!this.isSecondaryQuantity) {
      this.formGroupSo.get('receivedSecondaryQuantity').clearValidators();
      this.formGroupSo.get('receivedSecondaryQuantity').updateValueAndValidity();
    }
  }

  setPackSizeValidation() {
    if (!this.data.weight || !this.data.item.isPackSizeBasedCalculation) {
      return;
    }
    let calc = this.data.weight / this.data.pack;
    if (hasDecimal(calc)) {
      this.formGroupSo.controls['weight'].setErrors({ incorrect: true });
    } else {
      this.formGroupSo.controls['weight'].setErrors(null);
    }
  }

  getValidationforpack(data) {
    if (data.pack == 0 || data.pack == '') return true;
    else return false;
  }

  getValidationforqty(data) {
    if (data.weight == 0) return true;
    else return false;
  }

  getValidationforprice(data) {
    if (data.price == 0) return true;
    else return false;
  }

  setData() {
    if (this.data && this.sysConfigProductModel.isItemCodeSupport) {
      if (this.itemCodeList) {
        this.itemCodeList.map((codeItem) => {
          if (codeItem.item.id === this.data.item.id) {
            this.data.item = codeItem;
          }
        });
      }
      this.itemCodeProperties = this.data.itemProperties;
    }
    if (this.data && !this.sysConfigProductModel.isItemCodeSupport) {
      this.purityList = new Array<Puritymodal>();
      this.packageCapacityList = new Array<PackingDetailModel>();
      if (this.data.item) {
        this.purityList = this.data.item.itemDetails.map((item) => item.purity);
      }
      if (this.data.selectedPacking) {
        this.packageCapacityList = this.data.selectedPacking.capacityDetails;
      }
    }
    if (this.data && this.data.details && this.isUpdateComponentIML) {
      if (this.data.moisture.name === 'LID') {
        this.LidData = this.data;
        this.data = this.LidData.details;
      } else {
        this.LidData = this.data.details;
      }
      const price = this.data.price + this.LidData.price;
      this.data.price = price;
      console.log(this.data, this.LidData);
    }

    if (
      this.data.itemProperties &&
      this.data.itemProperties.length > 0 &&
      this.sysConfigProductModel.isItemCodeSupport
    ) {
      this.createFormControl(null, this.data);
    }
  }

  setValidation() {
    this.formGroupSo = this.formBuilder.group({
      isSet: [''],
      productName: ['', Validators.required],
      price: ['', Validators.required],
      weight: ['', Validators.required],
      receivedSecondaryQuantity: ['', [Validators.required, this.numberOnlyValidation]],
      packingType: [''],
      capacity: [''],
      packageCapacity: [''],
      isLabelProduct: [''],
      labelProduct: [''],
      // labelProduct: ['', Validators.required],
      lidisLabelProduct: [''],
      lidlabelProduct: [''],
      lidpurity: [''],
      lidmoisture: [''],
      lidph: [''],
      lidsolubility: [''],
      lidpackingType: [''],
      lidcapacity: [''],
      pack: [{value:'',disabled:true}],
      mrp: [''],
      remark: [''],
      conversionFactor: [''],
      gst: ['', Validators.max(100)],
      discount:[]
    });
    if (!this.sysConfigProductModel.labelSupport) {
      this.removeAddValidationCheck('labelProduct', false);
      this.removeAddValidationCheck('isSet', false);
    }
    if (this.isDiagonal) {
      this.removeAddValidationCheck('pack', true);
    }
    this.checkSystemParametersValidation();
  }
  get f() {
    return this.formGroupSo.controls;
  }

  onSubmit() {
    this.submitted = false;
    if (this.formGroupSo.invalid) {
      if(this.formGroupSo.get('weight').value != null && this.formGroupSo.get('weight').value != '' && this.formGroupSo.get('weight').invalid){
        this.toaster.error('Please Enter Quantity Multiple Of Packsize', 'Error');
      } else {
        this.toaster.error('Please fill all the details', 'Error');
      }
      return (this.submitted = true);
    }
    this.data.pack = Number(this.data.pack);
    this.productDetail();
    if (this.formGroupSo.valid) {
      let addMatirail: boolean = false;
      var tmpFunProd = this.productDetail();
      if (this.isDiagonal) {
        // if (tmpFunProd.pack == '' || tmpFunProd.pack == null) {
        //   return this.toaster.error('Please Enter PackSize of Product');
        // } else 
        if (tmpFunProd.pack == 0) {
          return this.toaster.error("Entered Product PackSize Can't be Zero");
        } else if (tmpFunProd.weight == 0) {
          return this.toaster.error("Entered Product Quantity Can't be Zero");
        } else if (tmpFunProd.price == 0) {
          return this.toaster.error("Entered Product Price Can't be Zero");
        }
      } else {
        if (tmpFunProd.weight == 0) {
          return this.toaster.error("Entered Product Quantity Can't be Zero");
        } else if (tmpFunProd.price == 0) {
          return this.toaster.error("Entered Product Price Can't be Zero");
        }
      }

      if (!this.isUpdateComponentIML) {
        if (this.parentList && this.parentList.salesOrderItemDetails) {
          this.parentList.salesOrderItemDetails.forEach((matirail) => {
            if (matirail.item.id === this.data.item.id) {
              console.log();
              if (
                this.itemsPropertystring(matirail.itemProperties) === this.itemsPropertystring(this.data.itemProperties)
              ) {
                if (confirm('Item already exists in list do you want to upadate Quantity')) {
                  matirail.weight = Number(this.data.weight) + Number(matirail.weight);
                  matirail.price = this.data.price;
                  matirail.totalAmt = this.data.totalAmt;
                  addMatirail = true;
                  this.toaster.success('Quantity updated successfully');
                  this.resetData();
                  return;
                } else {
                  addMatirail = true;
                  return;
                }
              }
            }
          });
        }
      }

      if (this.isUpdateComponentIML) {
        tmpFunProd.dispatchedQuantity = this.data.dispatchedQuantity;
        tmpFunProd.id = this.data.id;
        console.log("dataaa",tmpFunProd);
        this.saveCallback.emit(tmpFunProd);
        return;
      }

      if (!addMatirail) {
        const data = Object.assign({}, this.data);
        this.listofData.push(tmpFunProd);
        this.listSaveCallback.emit(this.listofData);
        return;
      }
    }

    if (this.listofData.length > 0) {
      this.listSaveCallback.emit(this.listofData);
    }

    // if (!this.isImlUpdateAdd && this.listofData && this.listofData.length > 0) {
    //   this.listSaveCallback.emit(this.listofData);
    // } else {

    //   if (this.formGroupSo.invalid) {
    //     return (this.submitted = true);
    //   }

    // }
  }

  resetData() {
    this.data = new SoDetailModal();
    this.itemProperties = [];
    this.dynamicProp = [];
  }

  private productDetail() {
    var tmpFunProd = new SoDetailModal();
    tmpFunProd.item = this.formGroupSo.controls.productName.value;
    tmpFunProd.price = this.formGroupSo.controls.price.value;
    tmpFunProd.weight = this.formGroupSo.controls.weight.value;
    tmpFunProd.remark = this.formGroupSo.controls.remark.value;
    tmpFunProd.mrp = this.formGroupSo.controls.mrp.value;
    tmpFunProd.gst = this.formGroupSo.controls.gst.value;
    tmpFunProd.discount = Number(this.formGroupSo.controls.discount.value);
    tmpFunProd.conversionFactor = this.formGroupSo.controls.conversionFactor.value;
    tmpFunProd.receivedSecondaryQuantity = this.formGroupSo.controls.receivedSecondaryQuantity.value;
    if (this.isDiagonal) {
      tmpFunProd.pack = this.formGroupSo.controls.pack.value;
    }
    this.getProductTotal();
    tmpFunProd.totalDiscount = this.data.discount;
    tmpFunProd.totalAmt = this.data.totalAmt;
    tmpFunProd.finalAmt = this.data.finalAmt;

    var tmpItemProp = [];
    console.log(this.dynamicProp);
    this.dynamicProp.forEach((c) => {
      var array = this.formGroupSo.controls[c].value;
      var propId = c.split('_')[1];
      var values = Array<ItemPropertyValues>();
      values.push(array);

      if (this.itemProperties && this.itemProperties.length > 0) {
        var itemProperty = this.itemProperties.find((p) => p.itemProperty.id == propId).itemProperty;
        var itemProp = new ItemProperties();
        itemProp = itemProperty;
        itemProp.itemPropertyValues = values;
        tmpItemProp.push(itemProp);
      }
    });
    this.data.itemProperties = tmpItemProp;
    tmpFunProd.itemProperties = tmpItemProp;
    tmpFunProd.itemProp = tmpItemProp;

    return tmpFunProd;
  }

  onCancel() {
    this.cancelCallback.emit(this.data);
  }

  getItemList() {
    this.commonService.getItemNameAndId().subscribe((response) => {
      this.validateResponse(response, () => {
        this.ItemList = new Array<ProductModal>();
        this.ItemList = response.dataList;
        this.labelProductList = new Array<ProductModal>();
        this.labelProductList = response.dataList;
        if (this.getAllFilter || this.currentParty) {
          this.ItemList = this.filterItemList(this.ItemList);
        }
        if (this.currentParty) {
          if (!this.isUpdateComponentIML) {
            this.data.customerLabel = undefined;
          }
          this.labelProductList = this.labelProductList.filter(
            (list) => list.customer && list.customer.id === this.currentParty.id
          );
        }
      });
    });
  }

  getItemCodeList() {
    this.commonService.getItemCodeList().subscribe((response) => {
      this.validateResponse(response, () => {
        this.itemCodeList = new Array<any>();
        this.itemCodeList = response.dataList;
        if (this.isUpdateComponentIML) {
          this.setData();
        }
      });
    });
  }

  filterProductList() {
    if (this.labelProductList && this.labelProductList.length !== 0) {
      const id = +this.sysConfigProductModel.label_key;
      this.labelProductList = this.utilFilterListById(this.labelProductList, id);
      this.filterLabelProductList = this.utilFilterListById(this.filterLabelProductList, id);
    }
  }

  utilFilterListById(list: Array<ProductModal>, id: number): Array<ProductModal> {
    list = list.filter((ls) => {
      if (ls && ls.productType && ls.productType.length !== 0) {
        const fnTypeProduct = ls.productType.find((type) => type.id === id);
        if (fnTypeProduct) {
          return true;
        }
      }
      return false;
    });
    return JSON.parse(JSON.stringify(list));
  }

  filterItemList(list: Array<ProductModal>): ProductModal[] {
    list = list.filter((ls) => {
      if (!ls.customer) {
        return true;
      }
      return ls.customer && this.currentParty ? ls.customer.id == this.currentParty.id : false;
    });
    return JSON.parse(JSON.stringify(list));
  }

  filterLabelList(list: Array<ProductModal>): ProductModal[] {
    if (this.data && this.data.customer && this.data.isLabelProduct) {
      this.labelProductList = this.labelProductList.filter(
        (ls) => ls.customer && ls.customer.id === this.data.customer.id
      );
    }
    return JSON.parse(JSON.stringify(list));
  }

  onSelectItem(item) {
    this.lastSoPrice = undefined;
    if (this.itemProperties && this.itemProperties.length > 0) {
      this.itemProperties.forEach((prop) => {
        var ctrlName = prop.itemProperty.name + '_' + prop.itemProperty.id + '_' + prop.time;
        this.formGroupSo.removeControl(ctrlName);
        this.dynamicProp = [];
      });
    }
    this.createFormControl(item, null);
  }

  onSelectItemCode(item) {
    this.itemCodeProperties = [];
    if (item.itemProperties) {
      this.itemCodeProperties = item.itemProperties;
    }
  }

  createFormControl(item, tmpPOProd) {
    if (item || (tmpPOProd && tmpPOProd.item)) {
      var itemId = item ? item.id : tmpPOProd.item.id;
      this.commonService.getItemById(itemId).subscribe((item) => {
        this.data.item = item.data;
        if (!this.isUpdateComponentIML) {
          this.data.pack = this.data.item.packSize;
          this.data.gst = this.data.item.gst;
          this.data.conversionFactor = this.data.item.conversionFactor
        }
        if (!this.isUpdateComponentIML && !this.detailEdit) {
          if(this.data.item.price)
          this.data.price = parseFloat(this.data.item.price.toFixed(2));
        }
        this.itemProperties = item.data.itemPropertyRels;
        this.itemProperties = this.itemProperties.filter((ls) => !ls.itemProperty.isCalculatedProperty);
        var time = new Date().getTime().toString();
        this.itemProperties.forEach((d) => (d.time = time));
        this.itemProperties.forEach((prop) => {
          var ctrlName = prop.itemProperty.name + '_' + prop.itemProperty.id + '_' + time;
          var find = tmpPOProd ? tmpPOProd.itemProperties.find((ip) => ip.id == prop.itemProperty.id) : null;
          this.formGroupSo.addControl(
            ctrlName,
            this.formBuilder.control(
              find
                ? find.itemPropertyValues[0]
                : prop.itemProperty &&
                  prop.itemProperty.itemPropertyValues &&
                  prop.itemProperty.itemPropertyValues.length == 1
                ? prop.itemProperty.itemPropertyValues[0]
                : ''
            )
          );
          this.formGroupSo.get(ctrlName).setValidators(Validators.required);
          this.dynamicProp.push(ctrlName);
        });
      });
    } else {
      this.itemProperties = new Array<POItemProperties>();
    }
  }

  onSelectLabel() {
    this.data.customer = undefined;
    if (this.data.customerLabel && this.data.customerLabel.customer) {
      this.data.customer = { ...this.data.customerLabel.customer };
    }
  }

  initMaterialProperties() {
    this.data.purity = undefined;
    this.data.ph = undefined;
    this.data.moisture = undefined;
    this.data.solubility = undefined;
    this.purityList = new Array<Puritymodal>();
    if (this.data.isSet) {
      this.LidData.purity = undefined;
      this.LidData.ph = undefined;
      this.LidData.moisture = undefined;
      this.LidData.solubility = undefined;
    }
  }

  async getPurityList() {
    if (this.data && this.data.item && this.data.item.itemDetails && this.data.item.itemDetails.length !== 0) {
      this.purityList = this.data.item.itemDetails.map((item) => item.purity);
    }
    this.data.purity = await this.defaultMaterialPropertiesService
      .setCostParamProperty(this.data.item, this.purityList)
      .then();
    if (this.data.isSet) {
      this.LidData.purity = await this.defaultMaterialPropertiesService
        .setCostParamProperty(this.data.item, this.purityList)
        .then();
    }
  }

  async setMaterialProperties() {
    if (this.data && this.data.item) {
      // stock param 1
      this.data.ph = await this.defaultMaterialPropertiesService.setStockParam1Ph(this.data.item).then();
      // stock param 2
      this.data.moisture = await this.defaultMaterialPropertiesService.setStockParam2Moisture(this.data.item).then();
      // stock param 3
      this.data.solubility = await this.defaultMaterialPropertiesService
        .setStockParam3Solubility(this.data.item)
        .then();
      if (this.data.isSet) {
        this.LidData.ph = await this.defaultMaterialPropertiesService.setStockParam1Ph(this.data.item).then();
        // stock param 2
        this.LidData.moisture = await this.defaultMaterialPropertiesService
          .setStockParam2Moisture(this.data.item)
          .then();
        // stock param 3
        this.LidData.solubility = await this.defaultMaterialPropertiesService
          .setStockParam3Solubility(this.data.item)
          .then();
      }
    }
  }

  getPackingList() {
    this.commonService.getPackingList().subscribe((response) => {
      this.validateResponse(response, () => {
        this.packingList = new Array<PackingModel>();
        this.packingList = response.dataList;
      });
    });
  }

  onSelectPacking(event: PackingModel) {
    this.data.packingType = undefined;
    this.data.packingCapacityDetails = undefined;
    this.data.selectedPackageCapacity = undefined;
    this.packageCapacityList = new Array<PackingDetailModel>();
    if (event) {
      this.data.packingType = event.id;
      event.capacityDetails.forEach((list) => {
        if (list.packingUOM && list.packingUOM.capacityDetails) {
          list.subPackingCapacity = list.packingUOM.capacityDetails.find((sub) => sub.id === list.packingUOMCapacity);
        }
      });
      this.packageCapacityList = event.capacityDetails;
    }
  }

  onSelectPackageCapacity(event: PackingDetailModel) {
    this.data.packingCapacityDetails = undefined;
    if (event) {
      this.data.packingCapacityDetails = event.id;
    }
  }
  onLabelProduct() {
    this.data.customer = undefined;
    this.data.customerLabel = undefined;
    this.setModuleParamConfigValidation();
  }
  setModuleParamConfigValidation() {
    if (this.data.isLabelProduct) {
      this.removeAddValidationCheck('labelProduct', true);
    } else {
      this.removeAddValidationCheck('labelProduct', false);
    }
  }
  removeAddValidationCheck(name: string, required: boolean) {
    this.formGroupSo.get(`${name}`).clearValidators();
    if (required) {
      this.formGroupSo.get(`${name}`).setValidators([Validators.required]);
    }
    this.formGroupSo.get(`${name}`).updateValueAndValidity();
  }

  ngAfterContentInit() {
    this.moduleParams = new soModuleParamConfigModel(this.moduleParamConfigGlob);
  }

  getLastPrice() {
    if (!this.data.item) return this.toaster.warning('Please Select Item', 'WARNING');
    let propertyValidation = false;
    this.dynamicProp.forEach((c) => {
      if (this.formGroupSo.controls[c].invalid) propertyValidation = true;
    });
    if (!propertyValidation) {
      this.productDetail();
      //this.data.itemProperties = this.productDetail();
      let soPriceAI = {
        itemId: this.data.item.id,
        partyId: this.currentParty.id,
        itemProperties: this.data.itemProperties,
      };
      this.commonService.getItemLastPriceByCustomerAndItem(soPriceAI).subscribe((res) => {
        this.lastSoPrice = new LastSOPrice();
        this.lastSoPrice = res.data;
      });
    } else return this.toaster.warning('Please Select All Item Properties');
  }
}
function hasDecimal(num) {
  return !!(num % 1);
}
